// A Pundit::NotAuthorizedError never redirects anymore (see
// ApplicationController#render_forbidden) - it re-renders the current
// response in place with a 403 status and an X-Toast-Message header. Turbo
// still treats that as a normal response and would swap it into the page or
// follow it as a visit, which is exactly the navigation we're avoiding. This
// listener intercepts it before Turbo acts on it: it reads the message off
// the header, shows it as a toast, and calls preventDefault() so Turbo drops
// the response entirely and the current page is left untouched.
//
// turbo:before-fetch-response fires for every Turbo-managed fetch - Drive
// visits, frame loads, and form submissions alike - so this one listener
// covers link clicks, forms, and frames without any per-controller wiring.
// Plain fetch() calls made outside Turbo (e.g. React components polling an
// API) never dispatch this event and are unaffected.
import { notifyError } from './toast'

const DEFAULT_MESSAGE = 'You are not authorized to perform this action.'

interface TurboBeforeFetchResponseEvent extends Event {
  detail: {
    fetchResponse?: {
      response: Response
    }
  }
}

export function handleForbiddenFetchResponse(event: TurboBeforeFetchResponseEvent): void {
  const response = event.detail?.fetchResponse?.response
  if (!response || response.status !== 403) return

  event.preventDefault()
  notifyError(response.headers.get('X-Toast-Message') || DEFAULT_MESSAGE)
}
